// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"GeneralInfoTooltip_tooltip__bKBG5","tooltipText":"GeneralInfoTooltip_tooltipText__32iF_","tooltipDescription":"GeneralInfoTooltip_tooltipDescription__2_yGQ"};